import React from 'react';
import { useFilters } from '../../hooks/useFilters';
import { CATEGORIES } from '../../utils/constants';
import CategorySelect from '../Common/CategorySelect';


const CategoryFilter = () => {
  const { filters, updateFilter } = useFilters();

  const toggleCategory = (slug) => {
    const current = filters.categories || [];
    const updated = current.includes(slug)
      ? current.filter(c => c !== slug)
      : [...current, slug];
    updateFilter('categories', updated);
  };

  return (
    <CategorySelect
      options={CATEGORIES.map(c => ({ value: c.name, label: c.name }))}
      selected={filters.categories}
      onToggle={toggleCategory}
    />
  );
};

export default CategoryFilter;
